import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import {
  Form as BaseForm,
  TextField,
  SubmitButton,
  CancelPopupButton,
} from 'ui/FormElement';
import { useContext } from '../Context';

export default function Form({ onHide }) {
  const FormSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().required('Email is required'),
  });

  const [loader, setLoader] = useState(false);

  const { dispatch, actions } = useContext();

  const formData = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    company: '',
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);
    actions.create(dispatch, values, () => {
      setLoader(false);
      swal('Affiliate Created');
      onHide();
      actions.load(dispatch);
    }, (errors) => {
      setLoader(false);
      errors.forEach((element) => {
        switch (element.source.pointer) {
          case '/data/attributes/email':
            setErrors({ email: element.detail });
            break;
          default:
            setErrors({ email: element.detail });
        }
      });
    });
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="firstName"
        label={(
          <>
            <span>First Name</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="lastName"
        label={(
          <>
            <span>Last Name</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="email"
        type="email"
        label={(
          <>
            <span>E-Mail</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="company"
        label={(
          <span>Company</span>
        )}
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={onHide}
        />
        <SubmitButton
          title={loader ? 'Please, wait ...' : 'Create'}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? 'not-possible-click' : ''
          }`}
        />
      </div>
    </BaseForm>
  );
}

Form.propTypes = {
  onHide: PropTypes.func.isRequired,
};
